/**
 * 合同申请
 */
import request from '@/utils/request'

export function getPage(condition, pagination) {
  return request({
    url: '/crm/contract/apply/page',
    method: 'post',
    data: { condition: condition, pagination: pagination }
  })
}

export function deleteById(id) {
  return request({
    url: '/crm/contract/apply/deleteById',
    method: 'post',
    data: { id: id }
  })
}
export function saveApplyInfo(data) {
  return request({
    url: '/crm/contract/apply/saveApplyInfo',
    method: 'post',
    data
  })
}

export function updateApplyInfo(data) {
  return request({
    url: '/crm/contract/apply/updateApplyInfo',
    method: 'post',
    data
  })
}
/**
 * 获取详情
 * @param id
 * @returns {AxiosPromise}
 */
export function get(id) {
  return request({
    url: '/crm/contract/apply/get',
    method: 'post',
    data: { id: id }
  })
}
